import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ResultSection: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    title
}) => (
    <VerticalContainer className={`${styles.resultSection} ${className}`} testId={testId}>
        <Wrapper className={styles.header} testId={`${testId}-header`}>
            {title}
        </Wrapper>

        {children}
    </VerticalContainer>
);

export default ResultSection;
